import { LoaderCircle, Mail, Send, Sparkles } from "lucide-react";

export const MissionControlCloserDesk = ({ deliverySummary, rows = [], onSendPreview, sendingAgentId = "" }) => {
  return (
    <section className="rounded-[32px] border border-[#001935]/10 bg-white/95 p-6 shadow-[0_20px_60px_rgba(0,25,53,0.08)] md:p-8" data-testid="mission-control-closer-desk">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#8b6d16]">Closer Desk</p>
          <h3 className="mt-2 text-2xl font-semibold text-[#001935]">Send Signature Preview on demand</h3>
          <p className="mt-3 max-w-3xl text-sm leading-7 text-[#42566f]">
            Use this live-demo tool to send the Boutique Cream Top 3 preview immediately for any active founding member, without waiting for the 8:00 AM SGT schedule.
          </p>
        </div>
        <div className="rounded-full border border-[#D4AF37]/25 bg-[#fffaf1] px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="mission-control-closer-seat-count">
          {rows.length} founder rows armed
        </div>
      </div>

      {deliverySummary ? (
        <div className="mt-5 grid gap-3 md:grid-cols-4" data-testid="mission-control-delivery-audit-summary">
          <div className="rounded-[20px] border border-[#001935]/10 bg-[#fffaf1] px-4 py-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Agent sends</p>
            <p className="mt-2 text-2xl font-semibold text-[#001935]">{deliverySummary.agent_sent_count || 0}</p>
          </div>
          <div className="rounded-[20px] border border-[#001935]/10 bg-[#fffaf1] px-4 py-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Archive sends</p>
            <p className="mt-2 text-2xl font-semibold text-[#001935]">{deliverySummary.archive_sent_count || 0}</p>
          </div>
          <div className="rounded-[20px] border border-[#001935]/10 bg-[#fffaf1] px-4 py-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Archive failures</p>
            <p className="mt-2 text-2xl font-semibold text-[#001935]">{deliverySummary.archive_failed_count || 0}</p>
          </div>
          <div className="rounded-[20px] border border-[#001935]/10 bg-[#fffaf1] px-4 py-4">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">Last delivery</p>
            <p className="mt-2 text-sm font-semibold text-[#001935]">{deliverySummary.last_delivery_at ? new Date(deliverySummary.last_delivery_at).toLocaleString() : "No sends yet"}</p>
          </div>
        </div>
      ) : null}

      <div className="mt-6 grid gap-4">
        {rows.map((row) => {
          const isSending = sendingAgentId === row.agent_id;
          return (
            <div className="rounded-[24px] border border-[#001935]/10 bg-[#fffaf1] p-5" data-testid={`mission-control-closer-row-${row.agent_id}`} key={row.agent_id}>
              <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full border border-[#D4AF37]/25 bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]" data-testid={`mission-control-closer-seat-${row.agent_id}`}>
                      Seat {row.seat_number}
                    </span>
                    <span className="rounded-full border border-[#001935]/10 bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-[#42566f]" data-testid={`mission-control-closer-plan-${row.agent_id}`}>
                      {row.plan_type || "Agent"}
                    </span>
                  </div>
                  <p className="mt-3 text-xl font-semibold text-[#001935]" data-testid={`mission-control-closer-name-${row.agent_id}`}>{row.agent_name}</p>
                  <div className="mt-2 flex flex-wrap items-center gap-3 text-sm text-[#42566f]">
                    <span className="inline-flex items-center gap-2" data-testid={`mission-control-closer-email-${row.agent_id}`}><Mail className="h-4 w-4 text-[#8b6d16]" /> {row.email || "No email configured"}</span>
                    {row.subdomain_slug ? <span data-testid={`mission-control-closer-path-${row.agent_id}`}>/agent/{row.subdomain_slug}</span> : null}
                  </div>
                </div>

                <div className="flex flex-col gap-3 xl:min-w-[360px] xl:items-end">
                  <div className="flex flex-wrap gap-2 text-[11px] font-bold uppercase tracking-[0.16em]">
                    <span className="rounded-full border border-[#001935]/10 bg-white px-3 py-1 text-[#42566f]" data-testid={`mission-control-closer-summary-date-${row.agent_id}`}>
                      Summary {row.latest_summary_date || "Pending"}
                    </span>
                    <span className="rounded-full border border-[#D4AF37]/25 bg-white px-3 py-1 text-[#8b6d16]" data-testid={`mission-control-closer-opportunities-${row.agent_id}`}>
                      Top 3 Ready: {row.strategic_opportunity_count || 0}
                    </span>
                  </div>
                  <button
                    className="gold-button !px-5 !py-3"
                    data-testid={`mission-control-send-signature-preview-${row.agent_id}`}
                    disabled={!row.email || isSending}
                    onClick={() => onSendPreview?.(row.agent_id)}
                    type="button"
                  >
                    {isSending ? <LoaderCircle className="mr-2 h-4 w-4 animate-spin" /> : <Sparkles className="mr-2 h-4 w-4" />}
                    {isSending ? "Sending Preview" : "Send Signature Preview"}
                  </button>
                  <p className="text-xs text-[#6b6252]" data-testid={`mission-control-closer-preview-note-${row.agent_id}`}>
                    Sends the Top 3 Boutique Cream preview instantly to the agent’s account email.
                  </p>
                </div>
              </div>
            </div>
          );
        })}

        {!rows.length ? (
          <div className="rounded-[24px] border border-dashed border-[#001935]/15 bg-[#fffaf1] px-4 py-6 text-sm text-[#6b6252]" data-testid="mission-control-closer-empty-state">
            No founding-member rows are ready yet.
          </div>
        ) : null}
      </div>
    </section>
  );
};